import { SalePageSaleStatus } from '@/api/types';
import { Tag } from '@/components';
import { DateTime } from '@/types/common';
import { isNil } from 'lodash-es';
import { SaleStartAtTag } from './SaleStartAtTag';

type SalePageStatusTagProps =
  | {
      saleStatus?: Exclude<SalePageSaleStatus, 'PLANNED'>;
    }
  | {
      saleStatus?: Extract<SalePageSaleStatus, 'PLANNED'>;
      startAt?: DateTime;
    };

const label = {
  ENDED: '판매 종료',
  SOLD_OUT: '품절',
  STOPPED: '판매 중지',
};

export const SalePageStatusTag = (props: SalePageStatusTagProps) => {
  const { saleStatus } = props;

  if (isNil(saleStatus)) return null;

  if (saleStatus === 'ON_SALE') {
    return null;
  } else if (saleStatus === 'PLANNED') {
    return <SaleStartAtTag startAt={props.startAt!} />;
  } else {
    return <Tag label={label[saleStatus]} variant="gray" size="small" />;
  }
};
